<style lang="less" scoped>
  @import "../assets/colorTheme";
  .el-card{
    margin-bottom: 20px;
    height: 140px;
  }
  .img-item{
    padding: 3px;
    background-color: #e8e8e8;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      max-width: 100%;
      max-height: 100px;
      cursor: pointer;
    }
  }
  .result-item{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .time-tag{
      height:auto;
      width: 100%;
      font-size: 13px;
      color: @mainColor - #111;
      line-height: 18px;
      text-align: center;
      white-space: normal;
      border-radius: 5px;
    }
  }
  .result{
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: center;
    justify-content: center;
    align-items: center;
    height: 65px;
    margin-bottom: 5px;
    font-size: 16px;
    color: white;
    border-radius: 5px;
    background-color: #F56C6C + #2b2b2b;
    .mode{
      display: none;
    }
    .number{
      display: flex;
      flex-direction: column;
      font-size: 28px;
      width: 100%;
      border-bottom: 1px solid white;
      justify-content: flex-end;
    }
    .label{
      font-size: 14px;
      height: 20px;
    }
    &.SUCCESS{
      background-color: #67C23A + #0f0f0f;
    }
  }
</style>

<template>
  <el-card>
    <el-row :gutter="8" type="flex">
      <el-col :span="8" class="img-item">
        <img :src="src(data.img1)" @click="openImg(data.img1)"/>
      </el-col>
      <el-col :span="8" class="result-item">
        <div class="result" v-if="data.matchNumber!==undefined" :class="data.compareResult">
          <div class="mode">
            {{data.route | route_name}}
          </div>
          <div class="number">{{data.matchNumber}}</div>
          <span class="label">{{data.compareMode.replace("模式","")}}置信度</span>
        </div>
        <div class="result fail" v-else>
          <div class="mode">
            {{data.route | route_name}}
          </div>
              
          <div class="content">
            {{data.result}}
          </div>
        </div>
        <el-tag class="time-tag">{{data.createTime | date_time}}</el-tag>
      </el-col>
      <el-col :span="8" class="img-item">
        <img :src="src(data.img2)" @click="openImg(data.img2)"/>
      </el-col>
    </el-row>

    <el-dialog title="图片详情" :visible.sync="visible" append-to-body>
      <div style="text-align: center">
        <img :src="src(currentImg)" style="max-width: 100%" />
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
  export default {
    props: {
      data: Object
    },
    data() {
      return {
        visible: false,
        currentImg: null
      }
    },
    methods: {
      src(key) {
        return this.$api.record.image1vs1({ id: this.data.id, key: key });
      },
      /*number(v){
        let result = JSON.parse(v.result);
        return Math.round(result.match / result.threshold * 100 * 100)/100;
      },*/
      openImg(img){
        this.visible = true;
        this.currentImg = img;
      }
    }
  }
</script>
